import { render, staticRenderFns } from "./GFReasonsForSeparationSlabs.vue?vue&type=template&id=75e0f2f8"
import script from "./GFReasonsForSeparationSlabs.vue?vue&type=script&lang=js"
export * from "./GFReasonsForSeparationSlabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports